import React from 'react';
import { Link } from 'react-router-dom';
import UserContainer from 'components/user-container';
import logo from 'images/logo.png';
import logoLight from 'images/logo-light.png';
import './index.scss';
import { useTypedSelector } from 'store/index';
import { Loading, Alert } from '@tencent/spaui';
// @ts-ignore
import orderStore from 'pages/orderDialog/store.js';
// @ts-ignore
import { activeAccountType } from 'common/const.js';
// @ts-ignore
import GuideManager from '../../business-components/guide-manager';

export interface TopBarProps {
  mode?: 'light' | 'dark';
  // 精简模式：只展示左侧 logo，隐藏右侧所有操作区（用于系统公告等场景）
  minimal?: boolean;
}

const agency = [activeAccountType.isvAgency, activeAccountType.proxyAgency];

const TopBar: React.FC<TopBarProps> = ({ mode, minimal }) => {
  const { user, loading } = useTypedSelector((state) => state.user);

  const canManageAgency = agency.includes(user?.active_account_type);

  let guidList: any = [
    {
      desc: '在这里免费发布您的项目需求，寻找合适服务商来提供服务',
      key: 'newDemand',
      label: '免费发布需求',
    },
    {
      desc: '在这里新增了发布需求管理，可查看您发布的需求',
      key: 'manageCenter',
      label: '管理中心',
    },
  ];

  if (!!canManageAgency) {
    guidList = [
      {
        desc: '在这里免费发布您的项目需求，寻找合适服务商来提供服务',
        key: 'newDemand',
        label: '免费发布需求',
      },
      {
        desc: '在这里新增了服务商后台商机管理，可查看您参与的需求',
        key: 'agencyManage',
        label: '服务商管理',
      },
      {
        desc: '在这里新增了发布需求管理，可查看您发布的需求',
        key: 'manageCenter',
        label: '管理中心',
      },
    ];
  }

  return (
    <div className="top-bar-wrapper">
      {/* <Alert type="warn">
        <span>
          【重要公告】尊敬的广告主、服务商及合作伙伴：腾讯广告营销服务市场各模块将于2026年4月30日
          00:00起进行正式升级改造，届时原有功能将关闭，请您务必在产品功能关闭前完成相关数据备份。由此给您带来的不便，敬请谅解！
          <a
            href="https://doc.weixin.qq.com/doc/w3_AF0A1wZ-ACcCNBotjPdakRGuHuVzN?scode=AJEAIQdfAAokg0oL8zAVMAJQYqAP0"
            target="_blank"
            rel="noreferrer"
          >
            公告详情 &gt;
          </a>
        </span>
      </Alert> */}
      <div className={`top-bar ${mode}`}>
        <Link className="logo-container" to="/" data-track="logo">
          <span className="logo" style={{ backgroundImage: `url("${mode === 'light' ? logoLight : logo}")` }} />
          <span className="split" />
          <span className="title">服务市场</span>
        </Link>
        {!minimal && (
          <div className="right">
            {user && (
              <div
                id="newDemand"
                data-mark="guide"
                onClick={() => {
                  orderStore.createOrder();
                }}
                className={`make-free-order-button linnk2application-list mode-color-${mode}`}
                style={{ cursor: 'pointer' }}
              >
                免费发布需求
              </div>
            )}
            {mode === 'dark' && !!canManageAgency && (
              <div className="top-container helper-container">
                <i className="icon-help" />
                <div className="dropdown">
                  <a
                    href="https://docs.qq.com/doc/DWUNKaEd4dmRPaW5W"
                    target="_blank"
                    rel="noreferrer"
                    data-track="link-manual"
                  >
                    服务商后台操作手册
                  </a>
                </div>
              </div>
            )}
            {!!canManageAgency && (
              <Link to="/manage?source=toolbar">
                <div id="agencyManage" data-mark="guide" className={`linnk2application-list mode-color-${mode}`}>
                  服务商管理
                </div>
              </Link>
            )}
            {mode === 'dark' && user?.user_id && (
              <div className="top-container helper-container">
                <i className="icon-help" />
                <div className="dropdown">
                  <a
                    href="https://docs.qq.com/doc/DWWxUSXJhYXZraklj"
                    target="_blank"
                    rel="noreferrer"
                    data-track="link-manual"
                  >
                    用户使用操作手册
                  </a>
                </div>
              </div>
            )}
            {user && (
              <Link to="/application-list" data-track="app-list">
                <div id="manageCenter" data-mark="guide" className={`linnk2application-list mode-color-${mode}`}>
                  管理中心
                </div>
              </Link>
            )}
            <UserContainer />
          </div>
        )}

        {!minimal && <Loading show={loading} type="page" className="page-loading" />}
        {!minimal && user && window.location.pathname === '/' && (
          <GuideManager flag="ISV_HOME_GUIDE_MANAGER_FLAG" guidList={guidList} />
        )}
      </div>
    </div>
  );
};

TopBar.defaultProps = {
  mode: 'dark',
  minimal: false,
};

export default TopBar;
